import { z } from 'zod'

import {
  type ChargeMethod,
  isChargeMethod,
  type NoneableChargeMethod,
} from './charge-method.ts'
import { isPartnerProgramKind } from './partner-program-kind.ts'

export const MoneyChargeMethodSchema = z
  .enum(['invoice', 'stripe', 'ams'])
  .brand<'ChargeMethod'>()

export type MoneyChargeMethod = Exclude<
  ChargeMethod,
  'mntn_credits' | 'meta' | 'tiktok' | 'linkedin'
>

export function isMoneyChargeMethod(
  value: NoneableChargeMethod
): value is MoneyChargeMethod {
  if (isChargeMethod(value)) {
    return !isPartnerProgramKind(value)
  }
  return false
}

export function assertMoneyChargeMethod(
  value: NoneableChargeMethod
): asserts value is MoneyChargeMethod {
  if (!isMoneyChargeMethod(value)) {
    throw new Error('Value is not a money charge method')
  }
}
